import { ModuleConsts } from 'client/util/Constants';
import { capitalize } from 'lodash';
import { userStateActionMap, userStateActionType } from 'client/systemusers/constants/SystemUserConstants';

const { activate, suspend } = userStateActionType;

/**
 * @module ActionType
 */

/**
 * This function creates common props for ActionType
 * @param {string} action
 * @returns {ActionType}
 */
function addActionTypeProps(action = '') {
  const { activated, suspended } = ModuleConsts.systemUser.accountStates;

  // activate or suspend
  this.type = action;

  // Process - activating or suspending
  this.action = userStateActionMap.get(action).verb;
  // Action description - activation or suspension
  this.description = userStateActionMap.get(action).noun;
  // Resulting access to resources - restore or remove
  this.resourceAccess = userStateActionMap.get(action).result;
  // Resulting user state - activated or suspended
  this.userState = userStateActionMap.get(action).adjective;

  // User account state
  this.accountState = action === activate ? activated : suspended;

  // Title case
  this.userStateTitle = capitalize(this.userState);
  this.descriptionTitle = capitalize(this.description);
  this.resourceAccessTitle = capitalize(this.resourceAccess);
  this.actionTitle = capitalize(this.action);
}

/**
 * This function creates props for ActivateAction
 * @param {string} action
 * @returns {ActivateAction}
 */
function ActivateAction() {
  addActionTypeProps.call(this, activate);
}

/**
 * This function creates props for SuspendAction
 * @param {string} action
 * @returns {SuspendAction}
 */
function SuspendAction() {
  addActionTypeProps.call(this, suspend);
}

export default {
  ActivateAction,
  SuspendAction,
};
